var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "complete_content" },
    [
      _c("dd-header", { attrs: { isMenuView: false } }),
      _vm._v(" "),
      _c("div", { staticClass: "container" }, [
        _c("section", [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "main_content" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "return_link" }, [
              _c("a", { on: { click: _vm.goLogin } }, [
                _vm._v("ログイン画面へ戻る")
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "login_form" }, [
            _c("div", { staticClass: "logo" }, [
              _c("h2", [
                _c("img", {
                  attrs: {
                    src: _vm.getImage("common/logo.png"),
                    alt: "ミリスタイル"
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", [_vm._v("My size, My lifestyle.")]),
              _vm._v(" "),
              _c("div", { staticClass: "regist_form" }, [_c("dd-login")], 1)
            ])
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("h2", [_vm._v("パスワード設定完了")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "thanks" }, [
      _c("li", [_vm._v("パスワードを再設定しました。")]),
      _vm._v(" "),
      _c("li", [_vm._v("引き続きmm/styleをご利用ください。")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8a3e1dbe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8a3e1dbe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/payment/pages/DcPasswordResetComplete.vue
// module id = null
// module chunks = 